module.exports = __webpack_public_path__ + "static/media/SCG_Chem.20f7a382.png";